import Semalt from './service';
export default {
    Semalt
};